export enum FeeTypeEnum {
    MDR = 'MDR',
    FLEX = 'MDRFLEX',
}
